import { Box, Stack } from "@mui/material";
import { Common, Custom } from "components";
import { useApp, useSession, useTheme } from "contexts";
import { Combines } from "helpers";
import { useNavigate } from "react-router-dom";
import { Helpers, Routes } from "utils";

export const Intro = () => {
  const navigate = useNavigate();

  const { t } = useApp();
  const { theme } = useTheme();
  const { isAuthenticated } = useSession();

  return (
    <Box py={theme.spacing.xxxl}>
      <Stack gap={theme.spacing.lg}>
        <Custom.Typography size={theme.font.lg} weight={theme.font.bold}>
          {t.component.common.intro.header}
        </Custom.Typography>
        <Common.Image src={Helpers.getImage("homepage_banner.png")} />
        <Custom.Typography
          component="pre"
          size={theme.font.xs}
          sx={{ whiteSpace: "pre-wrap" }}
        >
          {t.component.common.intro.headline}
        </Custom.Typography>
        <Stack gap={theme.spacing.xl}>
          <Custom.Button
            variant="contained"
            trailing="right"
            onClick={() => navigate(Routes.createnew)}
          >
            {t.button.create_potluck}
          </Custom.Button>
          {!isAuthenticated && (
            <Custom.Button
              variant="outlined"
              trailing="right"
              onClick={() =>
                navigate(
                  Combines.interpolateURL(Routes.useronboarding, { token: "" })
                )
              }
            >
              {t.button.create_user}
            </Custom.Button>
          )}
        </Stack>
      </Stack>
    </Box>
  );
};
